module.exports = __webpack_public_path__ + "static/media/clear.b840e171.svg";